import { Container, Sprite } from 'pixi.js';
import { app } from '..';

export class Tutorial extends Container {
    constructor(player) {
        super();

        this.player = player;
        this.update();

        this.init();

        // var tutorialFinished = false;
    }

    init() {
        //setting up PC sprites
        this.keyboard = new Sprite.from('keyboard');
        this.keyboard.anchor.set(0.5, 1);
        this.keyboard.scale.y = 0;
        this.keyboard.y = 272;
        this.addChild(this.keyboard);

        this.key_left = new Sprite.from('keyboard_down');
        this.key_left.anchor.set(0.5);
        this.key_left.x = 100;
        this.key_left.y = 250;
        this.key_left.scale.set(0.99);
        this.key_left.alpha = 0;
        this.addChild(this.key_left);

        this.key_right = new Sprite.from('keyboard_down');
        this.key_right.anchor.set(0.5);
        this.key_right.x = 156;
        this.key_right.y = 250;
        this.key_right.scale.set(0.99);
        this.key_right.alpha = 0;
        this.addChild(this.key_right);

        this.key_down = new Sprite.from('keyboard_down');
        this.key_down.anchor.set(0.5);
        this.key_down.x = 128;
        this.key_down.y = 250;
        this.key_down.scale.set(0.99);
        this.key_down.alpha = 0;
        this.addChild(this.key_down);

        this.key_up = new Sprite.from('keyboard_down');
        this.key_up.anchor.set(0.5);
        this.key_up.x = 128;
        this.key_up.y = 222;
        this.key_up.scale.set(0.99);
        this.key_up.alpha = 0;
        this.addChild(this.key_up);

        //setting up mobile sprites
        this.reticle = new Sprite.from('ghost_reticle');
        this.reticle.anchor.set(0.5);
        this.reticle.y = 520;
        this.reticle.x = 115;
        this.reticle.alpha = 0;
        this.addChild(this.reticle);

        this.hand = new Sprite.from('hand_icon');
        this.hand.anchor.set(0.5);
        this.hand.y = 600;
        this.hand.x = 170;
        this.hand.alpha = 0;
        this.addChild(this.hand);
    }

    startMobile(cb){
        //animating reticle
        app.tween(this.reticle)
            .wait(1000)
            .to({ alpha: 1 }, 500)
            .to({ alpha: 0 }, 500)
            .to({ alpha: 1 }, 500)
            .to({ alpha: 0 }, 500)
            .to({ alpha: 1 }, 500)
            .to({ alpha: 0 }, 500)
            .to({ alpha: 1 }, 500)
            .to({ alpha: 0 }, 500);

        //animating hand
        app.tween(this.hand)
            .wait(1000)
            .to({ alpha: 1 }, 500)
            .wait(4000)
            .to({ alpha: 0 }, 500)
            .call(() => {
                if (cb) cb()
            });

        app.tween(this.hand.scale, { loop: true})
            .to({ x: 0.93, y: 0.93 }, 900, createjs.Ease.sineInOut)
            .to({ x: 1, y: 1 }, 900, createjs.Ease.sineInOut);
    }

    start(cb) {
        //animating keyboard
        app.tween(this.keyboard.scale)
            .wait(1000)
            .to({ y: 1 }, 250, createjs.Ease.sineOut)
            .wait(5750)
            .to({ y: 0 }, 250, createjs.Ease.sineOut)
            .call(() => {
                if (cb) cb();
            });

        //animating left/right keys
        app.tween(this.key_left)
            .wait(1750)
            .to({ alpha: 1 }, 0, createjs.Ease.sineOut)
            .wait(250)
            .to({ alpha: 0 }, 0, createjs.Ease.sineOut)

            .wait(750)
            .to({ alpha: 1 }, 0, createjs.Ease.sineOut)
            .wait(250)
            .to({ alpha: 0 }, 0, createjs.Ease.sineOut);

        app.tween(this.key_right)
            .wait(2250)
            .to({ alpha: 1 }, 0, createjs.Ease.sineOut)
            .wait(250)
            .to({ alpha: 0 }, 0, createjs.Ease.sineOut)

            .wait(750)
            .to({ alpha: 1 }, 0, createjs.Ease.sineOut)
            .wait(250)
            .to({ alpha: 0 }, 0, createjs.Ease.sineOut);

        //animating up/down keys
        app.tween(this.key_up)
            .wait(3750)
            .to({ alpha: 1 }, 0, createjs.Ease.sineOut)
            .wait(250)
            .to({ alpha: 0 }, 0, createjs.Ease.sineOut)

            .wait(750)
            .to({ alpha: 1 }, 0, createjs.Ease.sineOut)
            .wait(250)
            .to({ alpha: 0 }, 0, createjs.Ease.sineOut);

        app.tween(this.key_down)
            .wait(4250)
            .to({ alpha: 1 }, 0, createjs.Ease.sineOut)
            .wait(250)
            .to({ alpha: 0 }, 0, createjs.Ease.sineOut)

            .wait(750)
            .to({ alpha: 1 }, 0, createjs.Ease.sineOut)
            .wait(250)
            .to({ alpha: 0 }, 0, createjs.Ease.sineOut);

        // return this.tutorialFinished = true;
    }

    update() {
        // console.log (this.tutorialFinished);
        this.x = this.player.x + (this.player.width * 0.18);
        this.y = this.player.y - this.player.height - (this.height * 0.5);
    }

}
